import { ajaxHandler } from './AjaxHandler';

import CookieHandler from './CookieHandler';

/* eslint no-undef: 0 */
const Config = window.vfEnvironmentConfig;

export default class StoreService {
    postQuoteRequest(params) {
        return this.api(`${Config.API_URL}/v0/public/quote-request`).postNoToken(params);
    }

    postNewsletter(params) {
        return this.api(`${Config.API_URL}/v0/public/newsletter`).postNoToken(params);
    }

    api(url) {
        return {
            get: (params) => ajaxHandler('GET', url, params, CookieHandler.getTokenCookie()),
            post: (params) => ajaxHandler('POST', url, params, CookieHandler.getTokenCookie()),
            postNoToken: (params) => ajaxHandler('POST', url, params),
            put: (params) => ajaxHandler('PUT', url, params, CookieHandler.getTokenCookie()),
            delete: (params) => ajaxHandler('DELETE', url, params, CookieHandler.getTokenCookie()),
        };
    }
}



// WEBPACK FOOTER //
// ./src/services/StoreService.js